import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from './api/config';
import AuthModal from './AuthModal';

const AppointmentModal = ({ doctorId, slot, onClose }) => {
  const [patientId, setPatientId] = useState(localStorage.getItem('patient_id') || null);
  const [message, setMessage] = useState('');
  const [showAuth, setShowAuth] = useState(!patientId);

  const bookAppointment = () => {
    axios
      .post(`${BASE_URL}/book_appointment.php`, {
        doctor_id: doctorId,
        patient_id: patientId,
        time: slot,
      })
      .then(res => {
        setMessage(res.data.message);
        setTimeout(() => onClose(), 2000);
      });
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ background: '#00000070' }}>
      <div className="modal-dialog">
        <div className="modal-content p-4">
          <h5>Book Appointment</h5>
          <p>Time: {slot}</p>

          {showAuth ? (
            <AuthModal onAuthSuccess={id => {
              setPatientId(id);
              localStorage.setItem('patient_id', id);
              setShowAuth(false);
            }} />
          ) : (
            <>
              <button className="btn btn-success" onClick={bookAppointment}>Confirm Booking</button>
              <button className="btn btn-secondary ms-2" onClick={onClose}>Close</button>
              <p className="mt-2 text-success">{message}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentModal;
